// jshint module: true

// Enable iOS classnames (is-ipad, is-iphone, is-ios)
if (navigator.userAgent.match(/(iPad)/gi)) {
  document.body.classList.add('is-ipad');
  document.body.classList.add('is-ios');
} else if (navigator.userAgent.match(/(iPhone)/gi)) {
  document.body.classList.add('is-iphone');
  document.body.classList.add('is-ios');
}



// WEBPACK FOOTER //
// ./website/assets/scripts/polyfills/enable-ios-classnames.js